<template>
    <div>
        <div v-loading="loading" class="describe-container">
            <zm-form label-position="left" label-width="150px" class="describe-form" v-if="Object.keys(data).length">
                <zm-form-item label="topicUrl">
                    <span v-if="!isCreateTopic">{{ data.topicUrl }}</span>
                    <zm-input v-model="form.topicUrl" v-if="isCreateTopic" style="width: 70%"></zm-input>
                    <zm-dropdown class="btn-contain" @command="handleCommand" trigger="click" v-if="!isCreateTopic">
                        <zm-button type="primary" class="btn-contain" plain :loading="loading || electLoading" style="margin-left: 5px">Operations</zm-button>
                        <zm-dropdown-menu slot="dropdown">
                            <zm-dropdown-item :command="{command: 'showQuery'}">
                                Query Task
                            </zm-dropdown-item>
                            <zm-dropdown-item v-if="hasPermission" :command="{command: 'deleteTopic'}">
                                Delete Topic
                            </zm-dropdown-item>
                            <zm-dropdown-item v-if="hasPermission" :command="{command: 'electPreferredLeaders'}">
                                Trigger Elect Preferred Leaders
                            </zm-dropdown-item>
                            <zm-dropdown-item v-if="hasPermission" :command="{command: 'showAcl', param: true}">
                                Create Acl
                            </zm-dropdown-item>
                            <zm-dropdown-item :command="{command: 'showAcl', param: false}">
                                Describe Acl
                            </zm-dropdown-item>
                        </zm-dropdown-menu>
                    </zm-dropdown>
                    <!-- <zm-button @click="showQuery" type="primary" plain size="small" style="margin: 0 10px;">Query Task</zm-button>
                    <zm-button @click="deleteTopic" type="danger" plain size="small" v-if="!isCreateTopic && isPage && hasPermission">Delete Topic</zm-button>
                    <zm-button @click="electPreferredLeaders" type="primary" plain size="small" v-if="!isCreateTopic && isPage && hasPermission" style="margin: 0 10px;" :loading="electLoading">Trigger Elect Preferred Leaders</zm-button> -->
                </zm-form-item>
                <zm-form-item label="internal" v-if="!isCreateTopic">
                    {{ data.internal }}
                </zm-form-item>
                <zm-form-item label="partitionNum">
                    <zm-input-number v-if="isCreateTopic" v-model="form.partitionNum" :min="1"></zm-input-number>
                    <span v-if="!isEditPartition && !isCreateTopic">{{ data.partitionNum }}</span>
                    <zm-button type="icon" icon="zm-icon-edit" v-if="!isEditPartition && !isCreateTopic && isPage && hasPermission" @click="isEditPartition = true"></zm-button>
                    <zm-input-number v-model="partition" v-if="isEditPartition && !isCreateTopic" :min="data.partitionNum"></zm-input-number>
                    <zm-button v-if="isEditPartition && !isCreateTopic" type="icon" icon="zm-icon-ok" @click="addPartition" :loading="partitionLoading"
                    :disabled="partition <= data.partitionNum" style="margin-left: 10px;">Save</zm-button>
                    <zm-button v-if="isEditPartition && !isCreateTopic" @click="isEditPartition = false" type="icon" icon="zm-icon-close">Cancel</zm-button>
                </zm-form-item>
                <zm-form-item label="factor">
                    <span v-if="!isCreateTopic">{{ data.factor }}</span>
                    <zm-input-number v-model="form.factor" v-if="isCreateTopic" :min="1"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="configs" class="config-form">
                    <span v-if="!isEditConfig && !isCreateTopic">{{ JSON.stringify(data.configs) }}</span>
                    <zm-button type="icon" icon="zm-icon-edit" v-if="!isEditConfig && !isCreateTopic && isPage && hasPermission" @click="showEditConfig"></zm-button>
                    <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled" v-if="(isEditConfig || isCreateTopic) && !configs.length">add config</zm-button>
                    <zm-table :data="configs" v-if="isEditConfig || isCreateTopic" v-loading="configLoading">
                        <zm-table-column prop="key" label="key">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                                <zm-select size="small" v-model="scope.row.key" v-else allow-create filterable clearable @change="setValue(scope.row)">
                                    <zm-option v-for="item in selectableKeys" :key="item.key"
                                        :value="item.key" :label="item.key"></zm-option>
                                </zm-select>
                            </template>
                        </zm-table-column>
                        <zm-table-column prop="value" label="value">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                                <zm-input size="small" v-model.trim="scope.row.value" v-else clearable></zm-input>
                            </template>
                        </zm-table-column>
                        <zm-table-column width="100px">
                            <!-- eslint-disable-next-line -->
                            <template slot="header" slot-scope="scope">
                                <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                            </template>
                            <template slot-scope="scope">
                                <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                                    @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-delete"
                                    @click="deleteParam(scope.row.key)"></zm-button>
                            </template>
                        </zm-table-column>
                    </zm-table>
                    <zm-button v-if="isEditConfig && !isCreateTopic" type="primary" icon="zm-icon-ok" @click="saveConfig" :loading="configLoading">Save</zm-button>
                    <zm-button v-if="isEditConfig && !isCreateTopic" @click="isEditConfig = false">Cancel</zm-button>
                </zm-form-item>
                <zm-form-item>
                    <zm-button v-if="isCreateTopic" type="primary" @click="saveTopic" :loading="loading">Save</zm-button>
                    <zm-button v-if="isCreateTopic" @click="cancelCreateTopic">Cancel</zm-button>
                </zm-form-item>
                <!-- <zm-form-item v-for="(item, index) in data.configs" :key="item" :label="index">
                    {{ item }}
                </zm-form-item> -->
            </zm-form>
            <zm-button type="danger" plain @click="showDelete" :loading="deleteLoading">Delete Topic Record</zm-button>
            <zm-input size="small" v-model.trim="search" v-if="data.partitions && !isCreateTopic"
                class="search-input" placeholder="input to search"></zm-input>
            <zm-table @selection-change="handleSelectionChange"
                :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
                resizable border v-if="data.partitions && !isCreateTopic">
                <zm-table-column type="selection" width="60px"></zm-table-column>
                <zm-table-column prop="partition" label="partition"></zm-table-column>
                <zm-table-column prop="startOffset" label="startOffset"></zm-table-column>
                <zm-table-column prop="endOffset" label="endOffset"></zm-table-column>
                <zm-table-column prop="leader" label="leader">
                    <template slot-scope="scope">
                        <span v-if="scope.row.leader">{{ scope.row.leader.id }}</span>
                    </template>
                </zm-table-column>
                <zm-table-column prop="replicas" label="replicas">
                    <template slot-scope="scope" v-if="scope.row.replicas">
                        <zm-popover v-for="item in scope.row.replicas" :key="item.id"
                            @show="getTopicLogdir(scope.row.partition, item.id)"
                            placement="right-start" style="margin-right: 2px;"
                            trigger="click">
                            <div>
                                <i v-if="loadingLogDir"  class="zm-icon-loading"></i>
                                <div v-else>
                                    <p v-for="item in Object.keys(replicaLogDir)" :key="item">
                                        {{ item }}: {{ replicaLogDir[item] }}
                                    </p>
                                </div>
                                <zm-button @click="showAlter(scope.row.partition, item.id)" type="primary">Alter</zm-button>
                            </div>
                            <zm-tag slot="reference" type="">{{ item.id }}</zm-tag>
                        </zm-popover>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isr" label="isr" :formatter="setIdHost"></zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap" v-if="data.partitions && !isCreateTopic">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
            <!-- <zm-button type="primary" @click="showAcl(true)">Create Acl</zm-button>
            <zm-button type="primary" @click="showAcl(false)" plain>Describe Acl</zm-button> -->
        </div>
        <zm-dialog :title="isCreateAcl ? 'Create Acl' : 'Describe Acl'" :visible.sync="aclVisible" append-to-body>
            <zm-form label-width="170px" :model="aclForm" ref="aclForm" :rules="rules">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="name" id="topicdecribe-acl-name"></tip>
                    </div>
                    <zm-input size="small" v-model="aclForm.name"></zm-input>
                </zm-form-item>
                <zm-form-item label="aclOperation" prop="aclOperation">
                    <div slot="label">
                        <tip label="aclOperation" id="topicdecribe-acl-aclOperation"></tip>
                    </div>
                    <zm-select size="small" v-model="aclForm.aclOperation">
                        <!-- <zm-option label="UNKNOWN" value="UNKNOWN"></zm-option> -->
                        <zm-option label="ANY" value="ANY" v-if="!isCreateAcl"></zm-option>
                        <zm-option label="ALL" value="ALL"></zm-option>
                        <zm-option label="READ" value="READ"></zm-option>
                        <zm-option label="WRITE" value="WRITE"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="aclPatternType" prop="aclPatternType">
                    <div slot="label">
                        <tip label="aclPatternType" id="topicdecribe-acl-aclPatternType"></tip>
                    </div>
                    <zm-select size="small" v-model="aclForm.aclPatternType">
                        <!-- <zm-option label="UNKNOWN" value="UNKNOWN"></zm-option> -->
                        <zm-option label="ANY" value="ANY" v-if="!isCreateAcl"></zm-option>
                        <zm-option label="MATCH" value="MATCH" v-if="!isCreateAcl"></zm-option>
                        <zm-option label="LITERAL" value="LITERAL"></zm-option>
                        <zm-option label="PREFIXED" value="PREFIXED"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="aclPermissionType" prop="aclPermissionType">
                    <div slot="label">
                        <tip label="aclPermissionType" id="topicdecribe-acl-aclPermissionType"></tip>
                    </div>
                    <zm-select size="small" v-model="aclForm.aclPermissionType">
                        <!-- <zm-option label="UNKNOWN" value="UNKNOWN"></zm-option> -->
                        <zm-option label="ANY" value="ANY" v-if="!isCreateAcl"></zm-option>
                        <zm-option label="DENY" value="DENY"></zm-option>
                        <zm-option label="ALLOW" value="ALLOW"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="host" :prop="isCreateAcl ? 'host' : ''">
                    <div slot="label">
                        <tip label="host" id="topicdecribe-acl-host"></tip>
                    </div>
                    <zm-input size="small" v-model="aclForm.host"></zm-input>
                </zm-form-item>
                <zm-form-item :prop="isCreateAcl ? 'principal' : ''">
                    <div slot="label">
                        <tip label="principal" id="topicdecribe-acl-principal"></tip>
                    </div>
                    <zm-input size="small" v-model="aclForm.principal"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="aclVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="submitAcl()" :loading="aclLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Query Task" :visible.sync="visible" append-to-body>
            <zm-form label-width="100px">
                <zm-form-item label="partition" prop="partition">
                    <div slot="label">
                        <tip label="partition" id="topicdecribe-query-partition"></tip>
                    </div>
                    <zm-input-number size="small" v-model="queryForm.partition" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="offset" prop="offset">
                    <div slot="label">
                        <tip label="offset" id="topicdecribe-query-offset"></tip>
                    </div>
                    <zm-input-number size="small" v-model="queryForm.offset" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="getTopicTask()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Query Task Result" :visible.sync="resultVisible" append-to-body show-close width="70%">
            {{ JSON.stringify(topicTaskResult) }}
            <div slot="footer">
                <zm-button size="small" @click="resultVisible = false">Cancel</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Alter Log Dir" :visible.sync="alterVisible" append-to-body show-close>
            <zm-form :model="alterForm" ref="alterForm" :rules="alterRules">
                <zm-form-item ptop="logDir">
                    <div slot="label">
                        <tip label="Log Dir" id="topicdecribe-alter-logDir"></tip>
                    </div>
                    <zm-select v-model="alterForm.logDir">
                        <zm-option v-for="item in logDirList" :key="item" :label="item" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="alterVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveAlter()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Delete Topic Record" :visible.sync="deleteVisible" append-to-body show-close>
            <zm-form>
                <zm-form-item>
                    <zm-checkbox v-model="deleteForm.deleteAll">
                        <tip label="deleteAll" id="topicdecribe-delete-deleteAll"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item v-if="deleteForm.deleteAll">
                    <div slot="label">
                        <tip label="deleteOffset" id="topicdecribe-delete-deleteOffset"></tip>
                    </div>
                    <zm-input-number v-model="deleteForm.deleteOffset" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <zm-table :data="selectedPartitionsTable" v-if="!deleteForm.deleteAll">
                <zm-table-column label="partition" prop="partition"></zm-table-column>
                <zm-table-column label="deleteOffset" prop="deleteOffset">
                    <template slot-scope="scope">
                        <zm-input-number v-model="scope.row.deleteOffset" :min="scope.row.startOffset" :max="scope.row.endOffset"></zm-input-number>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer">
                <zm-button size="small" @click="deleteVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveDelete()" :loading="deleteLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Describe Acl" :visible.sync="aclTableVisible" append-to-body show-close width="70%">
            <zm-table :data="aclList" resizable border v-loading="aclLoading">
                <zm-table-column prop="name" label="name"></zm-table-column>
                <zm-table-column prop="host" label="host"></zm-table-column>
                <zm-table-column prop="aclOperation" label="aclOperation"></zm-table-column>
                <zm-table-column prop="aclPermissionType" label="aclPermissionType"></zm-table-column>
                <zm-table-column prop="patternType" label="patternType"></zm-table-column>
                <zm-table-column prop="principal" label="principal"></zm-table-column>
                <zm-table-column width="70px">
                    <template slot-scope="scope">
                        <zm-button type="icon" icon="zm-icon-delete" @click="deleteAcl(scope.row)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
        </zm-dialog>
    </div>
</template>
<script>
import { getTopicDescribe, getTopicLogdir, getTopicTask, listTopicConfigItems, createTopic, updateTopic, deleteTopic,
addPartition, electPreferredLeaders, createAcl, deleteAcl, getAcl, getBrokerLogDir, alterTopicLogDirs, deleteTopicRecord } from '@/api/kafkaManage'
import tip from 'components/ToolTip/index'
export default {
    name: 'topicDescribe',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            isPage: false,
            loading: false,
            data: {},
            isEditPartition: false,
            partition: 0,
            partitionLoading: false,
            isEditConfig: false,
            configs: [],
            defaultConfigs: [],
            configLoading: false,
            search: '',
            replicaLogDir: '',
            loadingLogDir: false,
            visible: false,
            queryForm: {
                offset: 0,
                partition: 0
            },
            form: {
                channelId: '',
                configs: {},
                factor: '',
                topicUrl: '',
                partitionNum: ''
            },
            resultVisible: false,
            topicTaskResult: {},
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            },
            electLoading: false,
            aclVisible: false,
            aclTableVisible: false,
            isCreateAcl: false,
            aclLoading: false,
            aclList: [],
            aclForm: {
                aclOperation: '',
                aclPatternType: '',
                aclPermissionType: '',
                channelId: '',
                host: '',
                name: '',
                principal: ''
            },
            rememberAclDescribe: {},
            alterVisible: false,
            alterForm: {
                brokerId: '',
                channelId: '',
                logDir: '',
                partition: '',
                topicUrl: ''
            },
            logDirList: [],
            selectedPartitions: [],
            selectedPartitionsTable: [],
            deleteForm: {
                deleteOffset: '',
                partitionOffsets: {},
                deleteAll: false
            },
            deleteVisible: false,
            deleteLoading: false,
            alterRules: {
                logDir: [
                    { required: true, message: 'please select a logDir', trigger: 'blur' }
                ]
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                host: [
                    { required: true, message: 'please enter host', trigger: 'blur' }
                ],
                principal: [
                    { required: true, message: 'please enter principal', trigger: 'blur' }
                ],
                aclOperation: [
                    { required: true, message: 'please choose a aclOperation', trigger: 'blur' }
                ],
                aclPatternType: [
                    { required: true, message: 'please choose a aclPatternType', trigger: 'blur' }
                ],
                aclPermissionType: [
                    { required: true, message: 'please choose a aclPermissionType', trigger: 'blur' }
                ]
            }
        }
    },
    props: ['channelId', 'topicUrl', 'isCreateTopic'],
    created () {
        if (this.$route.name === 'Topic Describe') {
            this.isPage = true
        }
        this.fetchDescribe()
        this.fetchDefaultConfigs()
    },
    watch: {
        topicUrl () {
            this.fetchDescribe()
        },
        isCreateTopic () {
            if (this.isCreateTopic) {
                this.showCreateTopic()
            }
        }
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.data.partitions.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.data.partitions
        },
        selectableKeys () {
            let data = JSON.parse(JSON.stringify(this.defaultConfigs))
            this.configs.map(item => {
                data.map(j => {
                    if (item.key === j.key) {
                        data.splice(data.indexOf(j), 1)
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.configs.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    methods: {
        saveDelete () {
            const { channelId, topicUrl } = this
            const { deleteAll, deleteOffset } = this.deleteForm
            if (!deleteAll) {
                this.deleteForm.partitionOffsets = {}
                this.selectedPartitionsTable.map(item => {
                    this.deleteForm.partitionOffsets[item.partition] = item.deleteOffset
                })
                const data = {
                    channelId,
                    topicUrl,
                    partitionOffsets: this.deleteForm.partitionOffsets
                }
                this.deleteLoading = true
                deleteTopicRecord(data).then(response => {
                    this.$message.success('Delete success')
                    this.deleteVisible = false
                    this.selectedPartitions = []
                    this.selectedPartitionsTable = []
                    this.deleteLoading = false
                }).catch(() => {
                    this.deleteLoading = false
                })
            } else {
                const data = {
                    channelId,
                    topicUrl,
                    deleteOffset
                }
                this.deleteLoading = true
                deleteTopicRecord(data).then(response => {
                    this.$message.success('Delete success')
                    this.deleteVisible = false
                    this.selectedPartitions = []
                    this.selectedPartitionsTable = []
                    this.deleteLoading = false
                }).catch(() => {
                    this.deleteLoading = false
                })
            }
        },
        showDelete () {
            if (this.selectedPartitions.length) {
                this.selectedPartitionsTable = this.selectedPartitions.map(item => {
                    return {
                        partition: item.partition,
                        deleteOffset: item.endOffset,
                        startOffset: item.startOffset,
                        endOffset: item.endOffset
                    }
                })
            }
            this.deleteVisible = true
        },
        showAlter (partition, brokerId) {
            this.alterForm.channelId = this.channelId
            this.alterForm.topicUrl = this.topicUrl
            this.alterForm.brokerId = brokerId
            this.alterForm.partition = partition
            this.alterForm.logDir = ''
            getBrokerLogDir(this.channelId, brokerId).then(response => {
                this.logDirList = response.listBrokerLogDirResult.logDirs
            })
            this.alterVisible = true
        },
        saveAlter () {
            this.$refs.alterForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    alterTopicLogDirs(this.alterForm).then(response => {
                        this.$message.success('Alter log dir success')
                        this.alterVisible = false
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        showAcl (isCreateAcl) {
            this.isCreateAcl = isCreateAcl
            this.aclVisible = true
            this.aclForm.aclOperation = ''
            this.aclForm.aclPatternType = ''
            this.aclForm.aclPermissionType = ''
            this.aclForm.channelId = this.channelId
            this.aclForm.host = isCreateAcl ? '' : '*'
            this.aclForm.name = this.topicUrl
            this.aclForm.principal = ''
            this.$nextTick(() => {
                this.$refs.aclForm.clearValidate()
            })
        },
        submitAcl () {
            this.$refs.aclForm.validate((valid) => {
                if (valid) {
                    if (this.isCreateAcl) {
                        this.aclLoading = true
                        createAcl(this.aclForm).then(response => {
                            this.$message.success('Create success')
                            this.aclVisible = false
                            this.aclLoading = false
                        }).catch(() => {
                            this.aclLoading = false
                        })
                    } else {
                        this.aclLoading = true
                        getAcl(this.aclForm).then(response => {
                            this.rememberAclDescribe = JSON.parse(JSON.stringify(this.aclForm))
                            this.aclVisible = false
                            this.aclTableVisible = true
                            this.aclList = response
                            this.aclLoading = false
                        }).catch(() => {
                            this.aclLoading = false
                        })
                    }
                }
            })
        },
        deleteAcl (row) {
            this.$confirm('This will delete the acl. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.aclForm.aclOperation = row.aclOperation
                this.aclForm.aclPatternType = row.patternType
                this.aclForm.aclPermissionType = row.aclPermissionType
                this.aclForm.channelId = this.channelId
                this.aclForm.host = row.host
                this.aclForm.name = row.name
                this.aclForm.principal = row.principal
                this.aclLoading = true
                deleteAcl(this.aclForm).then(res => {
                    this.$message.success('Delete success')
                    getAcl(this.rememberAclDescribe).then(response => {
                        this.aclList = response
                        this.aclLoading = false
                    }).catch(() => {
                        this.aclLoading = false
                    })
                }).catch(() => {
                    this.aclLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showCreateTopic () {
            this.configs = this.defaultConfigs
            this.form.channelId = this.channelId
            this.form.configs = {}
            this.form.factor = 3
            this.form.topicUrl = ''
            this.form.partitionNum = 3
        },
        saveTopic () {
            this.form.configs = {}
            this.configs.map(item => {
                this.form.configs[item.key] = item.value
            })
            this.loading = true
            createTopic(this.form).then(response => {
                this.loading = false
                this.$emit('refresh', this.form.topicUrl)
            }).catch(() => {
                this.loading = false
            })
        },
        cancelCreateTopic () {
            this.$emit('cancelCreateTopic')
        },
        showQuery () {
            this.queryForm.offset = 0
            this.queryForm.partition = 0
            this.visible = true
        },
        electPreferredLeaders () {
            const h = this.$createElement
            this.$msgbox({
                title: 'Warning',
                message: h('p', null, [
                    h('b', { style: 'color: #333' }, 'This operation is supported by brokers with version 2.2.0 or higher. Continue?')
                ]),
                showCancelButton: true,
                confirmButtonText: 'Elect',
                cancelButtonText: 'Cancel',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.electLoading = true
                        electPreferredLeaders(this.channelId, this.topicUrl).then(res => {
                            if (res.successFlag) {
                                this.$message.success('Elect success')
                            } else {
                                const errMesasage = res.errorDetailMessage
                                this.$message.error(errMesasage.slice(errMesasage.indexOf('Exception:') + 10, errMesasage.length))
                            }
                            this.electLoading = false
                            this.$emit('refresh')
                        }).catch(() => {
                            this.electLoading = false
                        })
                    } else {
                        done()
                        this.$message({
                            type: 'info',
                            message: 'Elect canceled'
                        })
                    }
                }
            })
        },
        getTopicTask () {
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                partition: this.queryForm.partition,
                offset: this.queryForm.offset }
            this.loading = true
            getTopicTask(this.channelId, data).then(response => {
                this.topicTaskResult = response
                this.visible = false
                this.resultVisible = true
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getTopicLogdir (partition, replicas) {
            this.replicaLogDir = ''
            this.loadingLogDir = true
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                partition: partition,
                brokerId: replicas }
            getTopicLogdir(this.channelId, this.topicUrl, data).then(response => {
                this.replicaLogDir = response
                this.loadingLogDir = false
            }).catch(() => {
                this.loadingLogDir = false
            })
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        setIdHost (row, column, cellValue, index) {
            let string = ''
            if (cellValue) {
                for (let i = 0; i < cellValue.length; i++) {
                    string = string + cellValue[i].id
                    if (i !== cellValue.length - 1) {
                        string += ', '
                    }
                }
            }
            return string
        },
        showEditConfig () {
            this.configs = []
            Object.keys(this.data.configs).map(item => {
                this.configs.push({
                    key: item,
                    value: this.data.configs[item],
                    isEdit: false
                })
            })
            this.isEditConfig = true
        },
        saveConfig () {
            var configs = {}
            this.configs.map(item => {
                configs[item.key] = item.value
            })
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                configs: configs
            }
            this.configLoading = true
            updateTopic(data).then(() => {
                this.isEditConfig = false
                this.fetchDescribe()
                this.configLoading = false
            }).catch(() => {
                this.configLoading = false
            })
        },
        addPartition () {
            this.$confirm('This will add partition. Continue?', 'Warning', {
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                const data = {
                    channelId: this.channelId,
                    topicUrl: this.topicUrl,
                    newPartitionNum: this.partition
                }
                this.partitionLoading = true
                addPartition(data).then(() => {
                    this.partitionLoading = false
                    this.isEditPartition = false
                    this.fetchDescribe()
                }).catch(() => {
                    this.partitionLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Add partition canceled'
                })
            })
        },
        fetchDefaultConfigs () {
            listTopicConfigItems().then(response => {
                this.defaultConfigs = []
                Object.keys(response.configItems).map(item => {
                    this.defaultConfigs.push({
                        key: item,
                        value: response.configItems[item],
                        isEdit: false
                    })
                })
            })
        },
        setValue (row) {
            if (row.key) {
                this.defaultConfigs.map(item => {
                    if (row.key === item.key) {
                        row.value = item.value
                    }
                })
            }
        },
        deleteTopic () {
            this.$confirm('This will delete the topic. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteTopic(this.channelId, this.topicUrl).then(() => {
                    this.isEditPartition = false
                    this.loading = false
                    this.$emit('refresh')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        addParam () {
            this.configs.unshift({
                key: '',
                value: '',
                isEdit: true
            })
        },
        deleteParam (key) {
            if (key) {
                this.configs.map((item, index, arr) => {
                    if (item.key === key) {
                        this.configs.splice(index, 1)
                    }
                })
            } else {
                this.configs.shift()
            }
        },
        fetchDescribe (selectedTopic) {
            this.loading = true
            // if (selectedTopic) {
            //     this.topicUrl = selectedTopic
            // }
            const topicUrl = selectedTopic || this.topicUrl
            getTopicDescribe(this.channelId, topicUrl).then(response => {
                this.loading = false
                this.data = response
                this.partition = this.data.partitionNum
            }).catch(() => {
                this.loading = false
            })
        },
        handleSelectionChange (val) {
            this.selectedPartitions = val
        },
        handleCommand (command) {
            if (command.command === 'showQuery') {
                this.showQuery()
            } else if (command.command === 'deleteTopic') {
                this.deleteTopic()
            } else if (command.command === 'electPreferredLeaders') {
                this.electPreferredLeaders()
            } else if (command.command === 'showAcl') {
                this.showAcl(command.param)
            }
        }
    }
}
</script>
<style scoped>
.describe-form {
    margin: 10px;
    color: #747487;
    padding-right: 80px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
    padding-right: 80px;
}
.describe-container {
    min-height: 300px;
}
.config-form {
    line-break: anywhere;
    word-break: break-all;
}
</style>
